import React from 'react';
import styles from './project-headline.module.css';
import { Spring, config } from 'react-spring';
import ReactFitText from 'react-fittext';

const ProjectHeadline = ({
  headline,
  isHome,
  returnSection,
  colorOverride = '#ffffff',
  fontOverride = 'montbold',
}) => {
  const renderHeadline = animation => {
    return (
      <div style={animation}>
        <ReactFitText compressor={0.9} maxFontSize={70}>
          <h1
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: headline }}
            style={{ color: colorOverride, fontFamily: fontOverride }}
          />
        </ReactFitText>
      </div>
    );
  };

  const renderDefaultAnimation = () => {
    return (
      <Spring
        from={{ opacity: 0, transform: 'translateY(20px)' }}
        to={{ opacity: 1, transform: 'translateY(0)' }}
        delay={600}
        config={{ tension: 180, friction: 60 }}
      >
        {animation => renderHeadline(animation)}
      </Spring>
    );
  };

  const renderHomeAnimation = () => {
    return (
      <Spring
        from={{ opacity: 0, transform: 'translateY(20px)' }}
        to={{
          opacity: returnSection === 'active' ? 1 : 0,
          transform:
            returnSection === 'active' ? 'translateY(0)' : 'translateY(20px)',
        }}
        delay={600}
        config={{ tension: 180, friction: 60 }}
      >
        {animation => renderHeadline(animation)}
      </Spring>
    );
  };

  if (isHome !== true) {
    return renderDefaultAnimation();
  } else {
    return renderHomeAnimation();
  }
};
export default ProjectHeadline;



// WEBPACK FOOTER //
// ./src/components/project/project-hero/project-headline/index.js